import React from 'react';
import {
    ContractDetails,
    ContractualType,
} from '../../../store/userDetailsSlice';
import { Formik } from 'formik';
import ProfileContractDetailsForm, {
    validateContractDetails,
} from './profile-contract-details-form';
import PbFormikObserver from './PbFormikObserver';

const DEFAULT_CONTRACTUAL_TYPE: ContractualType = 'WWB';

const DEFAULT_CONTRACT_VALUES: ContractDetails = {
    vat_exempted: false,
    vat_exemption_reason: '',
    vat_id: '',
    vat_id_verification_error: '',
    vat_id_verification_error_type: undefined,
    vat_id_verification_status: undefined,
    tax_number: null,
    company_registration_number: '',
    contractual_type: DEFAULT_CONTRACTUAL_TYPE,
    contractual_wewash_share: 0,
    country_id: 0,
    pms_provider: null,
    tenant_id: null,
};

interface Props {
    contractDetails: Partial<ContractDetails>;
    defaultCountryId: number | undefined;
    internalManager?: boolean;
    onChange: (values: ContractDetails & { _valid: boolean }) => void;
}

function ProfileContractDetailsFormWrapper(props: Readonly<Props>) {
    const initialValues: ContractDetails = {
        ...DEFAULT_CONTRACT_VALUES,
        ...props.contractDetails,
    };
    if (
        initialValues.country_id == undefined ||
        initialValues.country_id === 0
    ) {
        initialValues.country_id = props.defaultCountryId ?? 0;
    }

    return (
        <Formik
            initialValues={initialValues}
            validate={validateContractDetails}
            onSubmit={props.onChange}
        >
            {renderContent}
        </Formik>
    );

    function renderContent() {
        return (
            <>
                <PbFormikObserver onChange={props.onChange} />
                <ProfileContractDetailsForm
                    isAdmin={props.internalManager}
                    mayChangeCountry={props.internalManager}
                />
            </>
        );
    }
}

export default ProfileContractDetailsFormWrapper;
